export const LoadDirection = {
  up: "up",
  down: "down",
  both: "both",
};
